import { number, object, string } from "yup";
import type { Deal, DealType } from "~/models/Deal";
import { NOW_ACCEPTING } from "~/models/Status";
import type { DealTodo } from "./DealTodo";

export type TodoTemplate = {
	dealType: DealType;
	id: number;
	memo: string | null;
	statusId: number;
	statusName: string;
	subtypeId: number | null;
	title: string;
};

export type TodoTemplateEdit = Omit<TodoTemplate, "id" | "statusName">;

export const buildInitialTodoTemplateEdit = (
	dealType: DealType,
	subtypeId: number | null
): TodoTemplateEdit => ({
	dealType,
	memo: "",
	statusId: NOW_ACCEPTING,
	subtypeId,
	title: ""
});

export const validationSchema = object().shape({
	statusId: number().required("入力してください"),
	title: string().required("入力してください")
});

export const filterTodoTemplatesByDealType = (
	dealType: DealType,
	subtypeId: number | null,
	todoTemplates: TodoTemplate[] | null
): TodoTemplate[] =>
	todoTemplates === null
		? []
		: todoTemplates.filter(
				(todoTemplate) =>
					todoTemplate.dealType === dealType &&
					todoTemplate.subtypeId === subtypeId
			);

/** ステータスからTODOテンプレートをフィルタリングする */
export const filterTodoTemplatesByStatus = (
	deal: Deal,
	statusId: number,
	todoTemplates: TodoTemplate[]
): TodoTemplate[] => {
	if (deal.dealSubtype) {
		const { dealSubtype } = deal;
		return todoTemplates.filter(
			(template) =>
				template.statusId === statusId && template.subtypeId === dealSubtype.id
		);
	}
	return todoTemplates.filter(
		(template) =>
			template.statusId === statusId && template.dealType === deal.dealType
	);
};

/** TODOテンプレートから未作成のTODOの件数 */
export const countUncreatedByTemplates = (
	dealTodos: DealTodo[],
	todoTemplates: TodoTemplate[]
): number =>
	todoTemplates.reduce(
		(missingCount, template) =>
			dealTodos.some((todo) => todo.todoTemplateId === template.id)
				? missingCount
				: missingCount + 1,
		0
	);
